<div class="login-page">
    <!-- Top-right toolbar -->
    <div class="login-toolbar">
        <!-- Language Picker -->
        <div class="picker-wrap">
            <button class="toolbar-btn" (click)="toggleLangPicker()" title="Language">
                <span class="lang-flag">{{ activeLang === 'en' ? '🇬🇧' : activeLang === 'ms' ? '🇲🇾' : '🇨🇳' }}</span>
            </button>
            <div class="picker-dropdown lang-dropdown" *ngIf="showLangPicker">
                <button *ngFor="let lang of languages"
                    class="lang-option"
                    [class.active]="activeLang === lang.code"
                    (click)="applyLang(lang)">
                    <span class="lang-flag">{{lang.flag}}</span>
                    <span class="lang-label">{{lang.label}}</span>
                    <svg *ngIf="activeLang === lang.code" class="lang-check" xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0"/>
                    </svg>
                </button>
            </div>
        </div>

        <!-- Color Picker -->
        <div class="picker-wrap">
            <button class="toolbar-btn" (click)="toggleColorPicker()" title="Theme Color">
                <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 -960 960 960" width="16" fill="currentColor"><path d="M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 32.5-156t88-127Q256-817 330-848.5T488-880q80 0 151 27.5t124.5 76q53.5 48.5 85 115T880-518q0 115-70 176.5T640-280h-74q-9 0-12.5 5t-3.5 11q0 12 15 34.5t15 51.5q0 50-27.5 74T480-80Zm0-400Zm-220 40q26 0 43-17t17-43q0-26-17-43t-43-17q-26 0-43 17t-17 43q0 26 17 43t43 17Zm120-160q26 0 43-17t17-43q0-26-17-43t-43-17q-26 0-43 17t-17 43q0 26 17 43t43 17Zm200 0q26 0 43-17t17-43q0-26-17-43t-43-17q-26 0-43 17t-17 43q0 26 17 43t43 17Zm120 160q26 0 43-17t17-43q0-26-17-43t-43-17q-26 0-43 17t-17 43q0 26 17 43t43 17ZM480-160q9 0 14.5-5t5.5-13q0-14-15-33t-15-57q0-42 29-67t71-25h70q66 0 113-38.5T800-518q0-121-92.5-201.5T488-800q-136 0-232 93t-96 227q0 133 93.5 226.5T480-160Z"/></svg>
            </button>
            <div class="picker-dropdown color-dropdown" *ngIf="showColorPicker">
                <div class="picker-title">Theme</div>
                <div class="color-grid">
                    <button *ngFor="let t of themeColors"
                        class="color-swatch"
                        [class.active]="activeColor === t.color"
                        [style.background]="'rgb(' + t.color + ')'"
                        [title]="t.name"
                        (click)="applyColor(t)">
                        <svg *ngIf="activeColor === t.color" xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 16 16" [style.color]="t.text">
                            <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0"/>
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Backdrop to close dropdowns -->
    <div class="picker-backdrop" *ngIf="showColorPicker || showLangPicker" (click)="closeDropdowns()"></div>

    <!-- Login Card -->
    <div class="login-card">
        <div class="login-header">
            <img src="/assets/winwin-horizontal.png" class="login-logo" alt="Logo" />
            <h2 class="login-title">{{labels.welcome}}</h2>
            <p class="login-subtitle">{{labels.subtitle}}</p>
        </div>

        <form class="login-form" (submit)="login()">
            <div class="form-field">
                <label class="form-label">{{labels.username}}</label>
                <div class="input-wrapper">
                    <svg class="input-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z"/>
                    </svg>
                    <input type="text" name="username" [(ngModel)]="user.username" [placeholder]="labels.usernamePh" autocomplete="username" />
                </div>
            </div>

            <div class="form-field">
                <label class="form-label">{{labels.password}}</label>
                <div class="input-wrapper">
                    <svg class="input-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2m3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M5 8h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1"/>
                    </svg>
                    <input type="password" name="password" [(ngModel)]="user.password" [placeholder]="labels.passwordPh" autocomplete="current-password" />
                </div>
            </div>

            <button type="submit" class="login-btn" [disabled]="is_loading">
                <span *ngIf="!is_loading">{{labels.signIn}}</span>
                <span *ngIf="is_loading" class="spinner"></span>
            </button>
        </form>

        <p class="login-footer">{{labels.footer}}</p>
    </div>
</div>
